import gameStore from '../../store/GameStore';
import playerStore from '../../store/PlayerStore';
import { dateFromString } from '../../utils/date.utils';
import { WEvent } from './WEvent';

export class WPlayerTurnStartedEvent extends WEvent {
  gameId: string;
  pid: string;

  constructor(event: WPlayerTurnStartedEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      playerStore.modifyPlayers(game.players, this.pid, player => {
        player.sittingOut = false;
        player.notParticipating = false;
      });
      game.setAvailableAction(null);
      game.setActivePid(this.pid);
      game.setTurnStartingTime(dateFromString(this.eventTime));
    });
}
